import { createClient } from '@supabase/supabase-js';

const supabaseUrl =
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_SUPABASE_URL) ||
  'https://fkejrsmldbtkhnsnsnjc.supabase.co';

const supabaseAnonKey =
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_SUPABASE_ANON_KEY) ||
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZrZWpyc21sZGJ0a2huc25zbmpjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTI1NzQzNTUsImV4cCI6MjEwODE1MDM1NX0.eVVii2-gvx-zGu4B2yTzrbSTqSFySQHEqr5H1Z4FGrc';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
  },
});

/**
 * Função utilitária de upload automático para o Supabase Storage
 */
export async function uploadToStorage(bucket, file, customName = null) {
  if (!file) return null;
  if (typeof file === 'string') {
    // Se já for URL (ex: Cloudinary anterior ou link externo), retorna direto
    return file;
  }

  // Verifica se é um objeto File ou Blob válido
  if (!(file instanceof Blob) && !file.name) {
    return null;
  }

  const originalName = file.name || 'arquivo';
  const cleanName = originalName
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-zA-Z0-9._-]/g, '_')
    .toLowerCase();

  const fileName = customName || `${Date.now()}_${cleanName}`;

  const { error: uploadError } = await supabase.storage
    .from(bucket)
    .upload(fileName, file, { cacheControl: '3600', upsert: true });

  if (uploadError) {
    console.error(`Erro ao fazer upload para o bucket ${bucket}:`, uploadError);
    throw uploadError;
  }

  const { data } = supabase.storage.from(bucket).getPublicUrl(fileName);
  return data.publicUrl;
}
